/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Button from '@xanadu/ui-shared/components/widgets/Button';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';
import { submitReleaseFeedbackRequest } from '@xanadu/ui-shared/modules/releaseFeedback/actions';

import { getClientString } from '../../utils';

import styles from './Rating.module.scss';
import Star from './Star';

export const Rating = ({
  totalStars,
  releaseDate,
  setRated,
  releaseDescription,
  userId,
  clientName,
  clientSite,
  submitReleaseFeedback,
}) => {
  const [starsSelected, selectStar] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState('');
  const feedbackInput = useRef();

  const { t } = useImprovedTranslation();
  const clientString = getClientString(clientName, clientSite);

  const stars = [...Array(totalStars).keys()];

  const handleStarSelection = (index) => {
    selectStar(index + 1);
  };

  const handleTextFeedback = (e) => {
    setFeedback(e.target.value);
  };

  const handleButtonClick = () => {
    setRated(true);

    // Dispatch the action to submit release feedback
    submitReleaseFeedback({
      feedback,
      releaseDate,
      releaseDescription,
      starsSelected,
      userId,
      clientString,
      clientSite,
    });
  };

  const buttonClass = classNames({
    [styles.button]: true,
    [styles['button--disable']]: starsSelected === 0,
  });

  return (
    <div className={styles.starRating}>
      <div className={styles.starsContainer}>
        <div className={styles.label}>{t('Your Score')} : </div>
        <div className={styles.starsRow}>
          {stars.map((n, i) => (
            <Star
              key={n}
              starId={1 + stars[i]}
              setHover={setHover}
              hover={hover}
              starsSelected={starsSelected}
              onClick={() => {
                handleStarSelection(i);
              }}
            />
          ))}
        </div>
      </div>
      <div className={styles.feedbackTitle}>
        <span>{t('Your Feedback')}</span>
        <span>{`${280 - feedback.length}/280`}</span>
      </div>
      <textarea
        ref={feedbackInput}
        className={styles.feedback}
        onChange={(e) => handleTextFeedback(e)}
        placeholder={`${t('Your Feedback')}...`}
        maxLength="280"
        value={feedback}
      />
      <div className={styles.buttonContainer}>
        <Button
          sizeType="wide"
          buttonType="primary"
          disabled={starsSelected === 0}
          className={buttonClass}
          onClick={handleButtonClick}
        >
          {t('Submit Feedback')}
        </Button>
      </div>
    </div>
  );
};

Rating.propTypes = {
  totalStars: PropTypes.number.isRequired,
  releaseDate: PropTypes.string.isRequired,
  releaseDescription: PropTypes.string.isRequired,
  setRated: PropTypes.func.isRequired,
  clientName: PropTypes.string.isRequired,
  clientSite: PropTypes.string.isRequired,
  userId: PropTypes.number,
  submitReleaseFeedback: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    userId: state.getIn(['user', 'userId']),
  };
}

const mapDispatchToProps = {
  submitReleaseFeedback: submitReleaseFeedbackRequest,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Rating));
